/** @module Enums */ /** typedoc */
var DiscountTypeEnum;
(function (DiscountTypeEnum) {
    DiscountTypeEnum["Percentage"] = "Percentage";
    DiscountTypeEnum["Amount"] = "Amount";
    DiscountTypeEnum["AmountPerUnit"] = "AmountPerUnit";
})(DiscountTypeEnum || (DiscountTypeEnum = {}));

export { DiscountTypeEnum };
